import $ from 'jquery';
const MODULE_NAME = 'sajatEroValidator';
export default angular.module(MODULE_NAME, []).directive('sajatEroValidator', function () {
	'ngInject';
	return {
		restrict: 'A',
		require: ['^form', 'ngModel'],
		link: function (scope, element, attrs, ctrls) {

			var formCtrl = null;
			var modelCtrl = null;

			for (var name in ctrls) {
				if (ctrls[name].$name == '$ctrl.kalkulatorForm') {
					formCtrl = ctrls[name];
				} else if (ctrls[name].$name == 'sajatEro') {
					modelCtrl = ctrls[name];
				}
			}

			modelCtrl.$validators.range = function (modelValue) {
				var valid = true;
				if (!scope.$ctrl.isKishaszonMukodes()) {
					if ($.isNumeric(modelValue) && typeof formCtrl.nettoVetelar != 'undefined' && formCtrl.nettoVetelar.$valid) {
						var sajatEroMinimuma = null;
						if (scope.$ctrl.kalk.finanszirozasFajtaja == 2) {
							sajatEroMinimuma = Math.round(scope.$ctrl.kalk.nettoVetelar * 0.1);
						} else if (scope.$ctrl.kalk.finanszirozasFajtaja == 3) {
							sajatEroMinimuma = Math.round(scope.$ctrl.kalk.nettoVetelar * 0.2);
						}
						valid = (modelValue >= sajatEroMinimuma);
					}
				}
				return valid;
			};

		}
	};
}).name;



// WEBPACK FOOTER //
// ./source/applications/kalkulator/eszkozkalkulator/validators/sajaterovalidator.js